import { Checkout } from '@40seas/entities/checkout';
import { Invoice } from '@40seas/entities/invoices';
import { z } from 'zod';

export class IntentResult {
    token: string;
    url: string;
    originalUrl: string;
}

export class InvoiceIntentResult extends IntentResult {
    invoice: Invoice;
    checkout?: Checkout;
}

export class CheckoutIntentResult extends IntentResult {
    checkout: Checkout;
}

export const IntentResultSchema = z.object({
    token: z.string(),
    url: z.string(),
    originalUrl: z.string(),
});

export const CheckoutIntentResultSchema = z.object({
    token: z.string(),
    url: z.string(),
    originalUrl: z.string(),
    checkout: z.any(), // Using z.any() since Checkout schema would need to be imported
});
